export default function Loader () {
    
    
      
    return (
        <div className='overlay'><div className="custom-loader"></div></div> // Display the loader while loading is true
    ) ;
}